import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseService } from 'src/app/core/services/api-base.service';

@Injectable({
  providedIn: 'root',
})
export class UserCatalogDataService extends ApiBaseService {
  switchCatalog(catalogId: string): Observable<any> {
    const httpOptions = this.getHttpOptions(true);
    return this.put<any>(`${this.url}`, { catalogId }, httpOptions);
  }
}
